import(/* webpackMode: "eager" */ "/home/runner/work/deckster.xyz-v2.0/deckster.xyz-v2.0/app/templates/page.tsx");
